import React, { Component } from "react";
import { withAuth0 } from "@auth0/auth0-react";

import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import contentData from "../utils/contentData";

class Content extends Component {
  render() {
    const { user, isAuthenticated, isLoading } = this.props.auth0;

    if (isLoading) {
      return <div>Loading...</div>;
    }

    if (!isAuthenticated) {
      return <div>Please log in to view claims</div>;
    }

    return (
      <div className="next-steps my-5">
        <h2 className="my-5 text-center">Claims!</h2>
        <Row className="d-flex justify-content-between">
          <Col md="12">
            <Card>
              <CardBody>
                <CardTitle tag="h5">User Claims</CardTitle>
                <pre style={{ background: '#f8f9fa', padding: '1rem', borderRadius: '0.25rem' }}>
                  {JSON.stringify(user, null, 2)}
                </pre>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withAuth0(Content);
